export const avatarImageLimit = 5; // Max file size for avatar is 5 MB
